import React, { Component } from "react";
import { dataMain } from "../../data.js";
import retrieveOwner from "../../logic/query.js";
import ArpeggioLogic from "../Arpeggio/ArpeggioLogic.js";
import { MPTAccessKeyPanel } from "../MptShared/MPTAccessKeyPanel.js";
import { MPTOwnerDisplay } from "../MptShared/MPTOwnerDisplay.js";
import { MPTSoundIdentifierPanel } from "../MptShared/MPTSoundIdentifierPanel.js";
import NavBar from "../NavBar/NavBar.js";
import SekansLogic from "../Sekans/SekansLogic.js";
import XopowoLogic from "../Xopowo/XopowoLogic.js";
import "./mptPageContent.css";

export default class MPTPageContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data,
      dataMain: this.props.dataMain,
      accessKeyPanel: this.props.data.accessKeyPanel,
      fullscreen: false,
      accessKeyPanelVisibility: true,
      soundIdentifierPanelVisibility: true,
      ownerDisplayVisibility: true,
      navBarVisibility: true,
      showStats: true,
      usedStats: {
        pad1: 0,
        pad2: 0,
        pad3: 0,
        pad4: 0,
        pad5: 0,
        pad6: 0,
        pad7: 0,
        pad8: 0,
        pad9: 0,
      },
      height: 0,
      width: 0,
      location: "standard",
      pageContentHeight: 0
    }
    this.toggleFullScreen = this.toggleFullScreen.bind(this)
    this.updateUsedStats = this.updateUsedStats.bind(this)
    this.mounted = false
  }

  componentDidMount() {
    this.mounted = true
    this.setContainersSize()
    this.fetchOpenSea()
    this.setSoundIdentifierPanel()
    this.loadLocalStats()
    this.loadEventListener()
    
  }

  componentWillUnmount() {
    this.mounted = false
    this.unloadEventListener()
  }

  async fetchOpenSea() {
    const result = await retrieveOwner(this.state.data.contractAdress, this.state.data.tokenId)
    const owner = result.top_ownerships[0].owner.user.username
    const ownerAddress = result.top_ownerships[0].owner.address
    if (this.mounted) this.setState({owner: owner, ownerAddress: ownerAddress})
  }

  setSoundIdentifierPanel() {
    switch(this.state.data.model) {
      case "xopowo": 
        this.setState({soundIdentifierPanel: dataMain.imgSrc[11], showStats: true})
        break

      case "sekans": 
        this.setState({soundIdentifierPanel: dataMain.imgSrc[17], showStats: false})
        break

      case "arpeggio": 
        this.setState({soundIdentifierPanel: dataMain.imgSrc[17], showStats: false})
        break

      default: break
    }
  }

  loadLocalStats() {
    const model = this.props.data.model
    const edition = this.props.data.edition
    const dataToLoad = `${model}.${edition}`

    const localDataLoaded = localStorage.getItem(dataToLoad)

    const data = JSON.parse(localDataLoaded)

    // console.log(data)
    
    if (localDataLoaded !== null && this.isMounted) {
      this.setState({usedStats: data})
    }
  }

  loadEventListener() {
    window.addEventListener('resize', event => {
      this.setContainersSize()
    })
  }

  unloadEventListener() {
    window.removeEventListener('resize', event => {
      this.setContainersSize()
    })
  }

  toggleFullScreen() {
    const currentLocation = this.state.location

    let location = ""

    if (currentLocation === "standard") location = "fullscreen"
    else location = "standard"
    
    this.setState(prevState => {
      return({fullscreen: !prevState.fullscreen, navBarVisibility: !prevState.navBarVisibility, accessKeyPanelVisibility: !prevState.accessKeyPanelVisibility, soundIdentifierPanelVisibility: !prevState.soundIdentifierPanelVisibility, ownerDisplayVisibility: !prevState.ownerDisplayVisibility, location: location})}, () => {
      this.setContainersSize()
    })
  }

  setContainersSize() {
    this.setMptPageContentSize()
  }

  setMptPageContentCenterBlockWidth() {
    const parentWidth = document.getElementById("mptPageContentCenterBlock").clientWidth

    let ratio = 0

    switch(this.state.location) {
      case "standard": 
        ratio = 45
        break
      
      case "fullscreen":
        ratio = 61
        break

      default: break
    }

    const width = parentWidth * ratio / 100

    this.setState({width: width}, () => {
      this.setContainerMptHeight()
    })
  }

  setContainerMptHeight() {
    let height = 0
    if (document.getElementById("container-MPT") !== null) {
      const width = document.getElementById('container-MPT').clientWidth
      height = width * 77 / 100
    }

    this.setState({height: height})
  }

  setMptPageContentSize() {
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth
    let height = 0
    switch(this.state.location) {
      case "standard":
        height = windowHeight - document.getElementById("navBar").clientHeight
        break

      case "fullscreen":
        height = windowHeight
        break

      default: break
    }
    this.setState({pageContentHeight: height, pageContentWidth: windowWidth}, 
      () => {
        this.setMptPageContentCenterBlockWidth()
      })
  }

  updateUsedStats(stats) {
    this.setState({usedStats: stats})
  }

  render() {
    let navBar = ""
    let blankMargeMpt = ""
    if (this.state.navBarVisibility) {
      navBar = <NavBar />
      blankMargeMpt = <div className="blank-margeMPT" />
    }

    let accesKeyPanel = ""
    if (this.state.accessKeyPanelVisibility) {
      accesKeyPanel = <MPTAccessKeyPanel data={this.state.accessKeyPanel} />
    }

    let soundIdentifierPanel = ""
    if (this.state.soundIdentifierPanelVisibility) {
      soundIdentifierPanel = <MPTSoundIdentifierPanel imgSrc={this.state.soundIdentifierPanel} usedStats={this.state.usedStats} showXopowo={this.state.showStats} />  
    }

    let ownerDisplay = ""
    if (this.state.ownerDisplayVisibility) {
      ownerDisplay = <MPTOwnerDisplay owner={this.state.owner} ownerAddress={this.state.ownerAddress} nftPath={this.state.data.nftPath} />
    }
    
    let fullScreenBtnClassName = ""
    this.state.fullscreen ? fullScreenBtnClassName = "fullscreenToggle fullscreenOn" : fullScreenBtnClassName = "fullscreenToggle fullscreenOff"

    let fullScreenBtnSrc = ""
    this.state.fullscreen ? fullScreenBtnSrc = this.state.dataMain.imgSrc[18] : fullScreenBtnSrc = this.state.dataMain.imgSrc[19]
    
    let edition = ""
    switch(this.state.data.model) {
      case "xopowo": 
        edition = <XopowoLogic data={this.state.data} height={this.state.height} width={this.state.width} updateUsedStats={this.updateUsedStats} />
        break
      
      case "sekans":
        edition = <SekansLogic data={this.state.data} height={this.state.height} width={this.state.width} />
        break 

      case "arpeggio":
        edition = <ArpeggioLogic data={this.state.data} height={this.state.height} width={this.state.width} />
        break 

      default: break
    }

    return (
      <React.Fragment >
        {navBar}
        {blankMargeMpt}
        <div className="mptPageContent" id="mptPageContent" style={{height: this.state.pageContentHeight, width: this.state.pageContentWidth}}>
          <div className="mptPageContentCenterBlock" id="mptPageContentCenterBlock">
            {accesKeyPanel}
            {edition}
            {soundIdentifierPanel}
          </div>
          {ownerDisplay}
          <img className={fullScreenBtnClassName} onClick={this.toggleFullScreen} src={fullScreenBtnSrc} alt="fullscreen btn" />
        </div>
        
      </React.Fragment>
    )
  }
}